import xappmediaProducts from "generated/products-xappmedia";
import xappaiProducts from "generated/products-xapp-ai";

export interface Product {
    id: string;
    name: string;
    active: boolean;
    description?: string;
    caption?: string;
    images?: string[];
    priceInCents?: number;
    price?: string;
    metadata?: {
        legacy?: string;
        chat?: string;
        gbm?: string;
        search?: string;
        form?: string;
        partner?: "lacrm" | "jobber" | string,
        ["live-chat"]?: string;
        integrations?: string;
        sku?: string;
    }
}

export function getProducts(filter?: { partner?: string, legacy?: boolean, id?: string }): Product[] {

    // Pull in the correct set of products depending on environment

    let products: Product[] = [];

    if (__ENV__ === "development") {
        // push both sets of products
        products.push(...xappmediaProducts);
        products.push(...xappaiProducts);
    } else {
        if (__ACCOUNT__ === "stentor") {
            // just for testing products.push(...xappaiProducts);
            products.push(...xappmediaProducts)
        } else if (__ACCOUNT__ === "studio") {
            products.push(...xappaiProducts);
        }
    }

    if (filter) {
        const { partner, legacy } = filter;

        if (partner) {
            const filtered = products.filter((product) => {
                return product?.metadata?.partner === partner;
            });

            products = filtered;
        }

        // slightly different, if partner is undefined we remove those with defined partners
        if (typeof partner === "undefined") {
            const filtered = products.filter((product) => {
                return !product?.metadata?.partner;
            });

            products = filtered;
        }

        if (typeof legacy === "boolean") {

            const lookingForLegacy = legacy ? "true" : "false";

            const filtered = products.filter((product) => {

                const legacy = product.metadata?.legacy;

                // if there isn't a value and lookingForLegacy is "false", we filter it out
                if (!legacy && lookingForLegacy === "false") {
                    return true;
                }

                return product.metadata?.legacy === lookingForLegacy;
            });

            products = filtered;
        }

        if (typeof filter.id === "string") {
            const filtered = products.filter((product) => {
                return product.id === filter.id;
            });

            products = filtered;
        }
    }

    return products;
}

export function supportsIntegrations(productId: string): boolean {
    const product = getProducts().find((product) => product.id === productId);

    if (!product) {
        return false;
    }

    return product.metadata?.integrations?.toLowerCase() === "true";
}

export function supportsSearch(productId: string): boolean {
    const product = getProducts().find((product) => product.id === productId);

    if (!product) {
        return false;
    }

    return product.metadata?.search?.toLowerCase() === "true";
}

/**
 *
 * @deprecated
 * @param productId
 * @returns
 */
export function supportsGBM(productId: string): boolean {
    const product = getProducts().find((product) => product.id === productId);

    if (!product) {
        return false;
    }

    return product.metadata?.gbm?.toLowerCase() === "true";
}

export function supportsLiveChat(productId: string): boolean {
    const product = getProducts().find((product) => product.id === productId);

    if (!product) {
        return false;
    }

    return product.metadata?.["live-chat"]?.toLowerCase() === "true";
}